export class BucketFileData{
    FileName:string;
    Bucket:string;
    DateOfUpload:Date;
    DownLoadFileURL:string;
    FileFolder:string;
    FolderName:string;
}
